import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

const AdminLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await authService.login(email, password);
            navigate('/admin/dashboard');
        } catch (err) {
            setError(err.response?.data?.message || 'Login failed. Please try again.');
            setLoading(false);
        }
    };

    return (
        <div style={{ 
            minHeight: '100vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)'
        }}>
            <div style={{
                background: 'rgba(255, 255, 255, 0.05)',
                padding: '60px',
                borderRadius: '20px',
                maxWidth: '450px',
                width: '100%',
                border: '1px solid rgba(201, 169, 110, 0.2)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                    <img src={`${process.env.PUBLIC_URL}/current-logo.png`} alt="Hav'n Interiors" style={{ height: '60px', marginBottom: '20px' }} />
                    <h2 style={{ fontSize: '32px', fontWeight: '300', marginBottom: '10px' }}>Admin Login</h2>
                    <p style={{ color: 'rgba(245, 241, 237, 0.6)' }}>Access your dashboard</p>
                </div>

                {error && (
                    <div style={{
                        padding: '15px',
                        background: 'rgba(230, 57, 70, 0.1)',
                        border: '1px solid rgba(230, 57, 70, 0.3)',
                        borderRadius: '8px',
                        color: '#E63946',
                        marginBottom: '20px',
                        fontSize: '14px'
                    }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: 'var(--text-light)',
                            letterSpacing: '0.5px'
                        }}>Email Address</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Enter your email"
                            style={{
                                width: '100%',
                                padding: '14px 16px',
                                fontSize: '15px',
                                border: '1px solid rgba(201, 169, 110, 0.2)',
                                borderRadius: '8px',
                                background: 'rgba(255, 255, 255, 0.05)',
                                color: 'var(--text-light)',
                                transition: 'all 0.3s ease',
                                outline: 'none'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = 'var(--accent-color)';
                                e.target.style.boxShadow = '0 0 0 3px rgba(201, 169, 110, 0.1)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = 'rgba(201, 169, 110, 0.2)';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>

                    <div className="form-group" style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: 'var(--text-light)',
                            letterSpacing: '0.5px'
                        }}>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="Enter your password"
                            style={{
                                width: '100%',
                                padding: '14px 16px',
                                fontSize: '15px',
                                border: '1px solid rgba(201, 169, 110, 0.2)',
                                borderRadius: '8px',
                                background: 'rgba(255, 255, 255, 0.05)',
                                color: 'var(--text-light)',
                                transition: 'all 0.3s ease',
                                outline: 'none'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = 'var(--accent-color)';
                                e.target.style.boxShadow = '0 0 0 3px rgba(201, 169, 110, 0.1)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = 'rgba(201, 169, 110, 0.2)';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>

                    <button 
                        type="submit" 
                        className="btn" 
                        style={{ 
                            width: '100%', 
                            marginTop: '20px',
                            padding: '16px',
                            fontSize: '16px',
                            fontWeight: '600',
                            letterSpacing: '0.5px',
                            background: 'linear-gradient(135deg, var(--accent-color) 0%, #B8935D 100%)',
                            color: '#000',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 15px rgba(201, 169, 110, 0.3)',
                            opacity: loading ? 0.7 : 1
                        }}
                        disabled={loading}
                        onMouseEnter={(e) => {
                            if (!loading) {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 20px rgba(201, 169, 110, 0.5)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!loading) {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 15px rgba(201, 169, 110, 0.3)';
                            }
                        }}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;

